export type Lang = 'bg' | 'en' | 'it' | 'ar' | 'zh' | 'ru';

export const translations: Record<Lang, Record<string, string>> = {
  bg: {
    // Nav
    nav_home: 'Начало',
    nav_about: 'За мен',
    nav_mission: 'Мисия',
    nav_experience: 'Опит',
    nav_testimonials: 'Отзиви',
    nav_clients: 'Клиенти',
    nav_contact: 'Контакти',
    nav_cta: 'Свържете се',
    nav_subtitle: 'Финансов анализатор',
    // Hero
    hero_title: 'Алекс Зингер',
    hero_subtitle: 'Професионален финансов анализатор',
    hero_desc: 'Бивш експерт в HSBC Bank с 25+ години опит в глобалните финансови пазари',
    hero_cta: 'Консултация',
    hero_learn: 'Научете повече',
    hero_years: 'Години опит',
    hero_clients: 'Доволни клиенти',
    hero_countries: 'Държави',
    // About
    about_title: 'За мен',
    about_p1: 'С над <b>25 години професионален опит</b> в глобалните финансови пазари, специализирам в дълбок анализ на инвестиционни възможности и стратегическо управление на портфейли.',
    about_p2: 'През годините на работа в <b>HSBC Bank</b>, развих експертиза в анализ на международни пазари, оценка на рискове и създаване на персонализирани инвестиционни стратегии за клиенти от цял свят.',
    about_p3: 'На <b>49 години</b> продължавам да помагам на инвеститори и компании да вземат информирани финансови решения, базирани на задълбочен технически и фундаментален анализ.',
    about_skill1_title: 'Технически анализ',
    about_skill1_desc: 'Експертиза в японски свещи, графични модели и индикатори',
    about_skill2_title: 'Глобални пазари',
    about_skill2_desc: 'Дълбоко познаване на международните финансови пазари',
    about_skill3_title: 'Управление на риска',
    about_skill3_desc: 'Стратегии за защита и оптимизация на инвестициите',
    // Experience
    exp_title: 'Професионален опит',
    exp_key: 'Ключови постижения:',
    exp1_period: '1998 - 2023',
    exp1_company: 'HSBC Bank',
    exp1_position: 'Старши финансов анализатор',
    exp1_desc: 'Ръководене на екип от анализатори, разработване на инвестиционни стратегии за институционални клиенти, анализ на глобални пазари и макроикономически тенденции.',
    exp1_a1: 'Управление на портфейли на стойност над $500M',
    exp1_a2: 'Разработка на 50+ успешни инвестиционни стратегии',
    exp1_a3: 'Консултиране на клиенти от 45+ държави',
    exp2_period: '1995 - 1998',
    exp2_company: 'Международна финансова корпорация',
    exp2_position: 'Финансов анализатор',
    exp2_desc: 'Анализ на развиващи се пазари, оценка на инвестиционни възможности, подготовка на финансови отчети и прогнози.',
    exp2_a1: 'Анализ на 100+ инвестиционни проекта',
    exp2_a2: 'Участие в международни финансови форуми',
    exp2_a3: 'Разработка на модели за оценка на риска',
    stat_certs: 'Сертификати',
    stat_projects: 'Проекти',
    stat_clients: 'Клиенти',
    stat_roi: 'ROI средно',
    // Testimonials
    test_title: 'Отзиви на клиенти',
    test_subtitle: 'Какво казват моите клиенти за работата ми',
    // Map
    map_title: 'Глобално присъствие',
    map_subtitle: 'Клиенти от цял свят се доверяват на моята експертиза',
    map_total: 'Общо клиенти по света',
    map_clients: 'клиенти',
    region_europe: 'Европа',
    region_asia: 'Азия',
    region_na: 'Северна Америка',
    region_sa: 'Южна Америка',
    region_africa: 'Африка',
    region_australia: 'Австралия',
    // Contact
    contact_title: 'Свържете се с мен',
    contact_subtitle: 'Готов съм да обсъдя вашите инвестиционни цели',
    contact_info: 'Информация за контакт',
    contact_email_label: 'Email',
    contact_phone_label: 'Телефон',
    contact_hours_label: 'Работно време',
    contact_hours_val: 'Пон - Пет: 9:00 - 18:00',
    contact_why: 'Защо да работите с мен?',
    contact_why1: '25+ години професионален опит',
    contact_why2: 'Персонализиран подход към всеки клиент',
    contact_why3: 'Доказани резултати и възвръщаемост',
    contact_why4: 'Глобална експертиза и мрежа',
    contact_messenger: 'Свържете се с мен директно чрез предпочитания от вас месинджър',
    contact_reply: 'Отговарям в рамките на 24 часа в работни дни',
    footer_title: 'Алекс Зингер',
    footer_subtitle: 'Професионален финансов анализатор',
    footer_copy: '© 2024 Алекс Зингер. Всички права запазени.',
    // Mission Bulgaria
    mission_badge: 'Мисия в България',
    mission_title: 'Мисия в България',
    mission_subtitle: 'Повишаване на финансовата грамотност и издигане на икономиката на България',
    mission_quote: 'Баща ми е българин — тази земя е в кръвта ми. Мечтата ми е да върна на България онова, което тя ми е дала.',
    mission_quote_author: 'Алекс Зингер',
    mission_p1: 'От <b>2023 година</b> активно работя с България с една ясна цел — да помогна на хората тук да разберат как работят финансовите пазари и как могат да изградят стабилно финансово бъдеще за себе си и семействата си.',
    mission_p2: 'Като син на <b>български баща</b>, винаги съм чувствал дълбока връзка с тази страна. Виждам огромен потенциал в българите — интелигентни, трудолюбиви и амбициозни хора, на които просто им липсва достъп до качествено финансово образование.',
    mission_p3: 'Моята цел е да <b>изградя финансово грамотно поколение</b> в България — хора, които разбират инвестициите, управляват рисковете и допринасят за растежа на националната икономика.',
    mission_since_label: 'Работя с България от',
    mission_since_val: '2023 година',
    mission_photo_caption: 'Алекс Зингер, София',
    mission_photo_sub: 'Катедрала „Александър Невски"',
    mission_stat1_num: '2023',
    mission_stat1_label: 'Начало на мисията',
    mission_stat2_num: '500+',
    mission_stat2_label: 'Обучени българи',
    mission_stat3_num: '20+',
    mission_stat3_label: 'Семинара и лекции',
    mission_stat4_num: '3',
    mission_stat4_label: 'Партньорски организации',
    mission_pillars_title: 'Стълбовете на мисията',
    mission_pillar1_title: 'Финансово образование',
    mission_pillar1_desc: 'Семинари, уебинари и лични консултации за повишаване на финансовата грамотност',
    mission_pillar2_title: 'Инвестиционна култура',
    mission_pillar2_desc: 'Обучение как да се инвестира разумно и да се изгражда дългосрочно богатство',
    mission_pillar3_title: 'Икономически растеж',
    mission_pillar3_desc: 'Подкрепа на местния бизнес и привличане на международни инвестиции в България',
    mission_pillar4_title: 'Лична ангажираност',
    mission_pillar4_desc: 'Работя лично с всеки клиент, защото вярвам в индивидуалния подход',
  },
  en: {
    nav_home: 'Home',
    nav_about: 'About',
    nav_mission: 'Mission',
    nav_experience: 'Experience',
    nav_testimonials: 'Reviews',
    nav_clients: 'Clients',
    nav_contact: 'Contact',
    nav_cta: 'Get in Touch',
    nav_subtitle: 'Financial Analyst',
    hero_title: 'Alex Zinger',
    hero_subtitle: 'Professional Financial Analyst',
    hero_desc: 'Former HSBC Bank expert with 25+ years of experience in global financial markets',
    hero_cta: 'Consultation',
    hero_learn: 'Learn More',
    hero_years: 'Years of Experience',
    hero_clients: 'Satisfied Clients',
    hero_countries: 'Countries',
    about_title: 'About Me',
    about_p1: 'With over <b>25 years of professional experience</b> in global financial markets, I specialize in deep analysis of investment opportunities and strategic portfolio management.',
    about_p2: 'During my years at <b>HSBC Bank</b>, I developed expertise in international market analysis, risk assessment, and creating personalized investment strategies for clients worldwide.',
    about_p3: 'At <b>49 years old</b>, I continue to help investors and companies make informed financial decisions based on thorough technical and fundamental analysis.',
    about_skill1_title: 'Technical Analysis',
    about_skill1_desc: 'Expertise in Japanese candlesticks, chart patterns and indicators',
    about_skill2_title: 'Global Markets',
    about_skill2_desc: 'Deep knowledge of international financial markets',
    about_skill3_title: 'Risk Management',
    about_skill3_desc: 'Strategies for protecting and optimizing investments',
    exp_title: 'Professional Experience',
    exp_key: 'Key Achievements:',
    exp1_period: '1998 - 2023',
    exp1_company: 'HSBC Bank',
    exp1_position: 'Senior Financial Analyst',
    exp1_desc: 'Leading a team of analysts, developing investment strategies for institutional clients, analyzing global markets and macroeconomic trends.',
    exp1_a1: 'Managing portfolios worth over $500M',
    exp1_a2: 'Developing 50+ successful investment strategies',
    exp1_a3: 'Consulting clients from 45+ countries',
    exp2_period: '1995 - 1998',
    exp2_company: 'International Finance Corporation',
    exp2_position: 'Financial Analyst',
    exp2_desc: 'Analysis of emerging markets, evaluation of investment opportunities, preparation of financial reports and forecasts.',
    exp2_a1: 'Analysis of 100+ investment projects',
    exp2_a2: 'Participation in international financial forums',
    exp2_a3: 'Development of risk assessment models',
    stat_certs: 'Certificates',
    stat_projects: 'Projects',
    stat_clients: 'Clients',
    stat_roi: 'Average ROI',
    test_title: 'Client Reviews',
    test_subtitle: 'What my clients say about working with me',
    map_title: 'Global Presence',
    map_subtitle: 'Clients from around the world trust my expertise',
    map_total: 'Total clients worldwide',
    map_clients: 'clients',
    region_europe: 'Europe',
    region_asia: 'Asia',
    region_na: 'North America',
    region_sa: 'South America',
    region_africa: 'Africa',
    region_australia: 'Australia',
    contact_title: 'Contact Me',
    contact_subtitle: 'Ready to discuss your investment goals',
    contact_info: 'Contact Information',
    contact_email_label: 'Email',
    contact_phone_label: 'Phone',
    contact_hours_label: 'Working Hours',
    contact_hours_val: 'Mon - Fri: 9:00 - 18:00',
    contact_why: 'Why work with me?',
    contact_why1: '25+ years of professional experience',
    contact_why2: 'Personalized approach to each client',
    contact_why3: 'Proven results and returns',
    contact_why4: 'Global expertise and network',
    contact_messenger: 'Contact me directly via your preferred messenger',
    contact_reply: 'I respond within 24 hours on business days',
    footer_title: 'Alex Zinger',
    footer_subtitle: 'Professional Financial Analyst',
    footer_copy: '© 2024 Alex Zinger. All rights reserved.',
    mission_badge: 'Mission in Bulgaria',
    mission_title: 'Mission in Bulgaria',
    mission_subtitle: 'Raising financial literacy and elevating the Bulgarian economy',
    mission_quote: 'My father is Bulgarian — this land is in my blood. My dream is to give back to Bulgaria what it has given me.',
    mission_quote_author: 'Alex Zinger',
    mission_p1: 'Since <b>2023</b>, I have been actively working with Bulgaria with one clear goal — to help people here understand how financial markets work and how they can build a stable financial future for themselves and their families.',
    mission_p2: 'As the son of a <b>Bulgarian father</b>, I have always felt a deep connection to this country. I see enormous potential in Bulgarians — intelligent, hardworking and ambitious people who simply lack access to quality financial education.',
    mission_p3: 'My goal is to <b>build a financially literate generation</b> in Bulgaria — people who understand investments, manage risks and contribute to the growth of the national economy.',
    mission_since_label: 'Working with Bulgaria since',
    mission_since_val: 'Year 2023',
    mission_photo_caption: 'Alex Zinger, Sofia',
    mission_photo_sub: 'Alexander Nevsky Cathedral',
    mission_stat1_num: '2023',
    mission_stat1_label: 'Mission started',
    mission_stat2_num: '500+',
    mission_stat2_label: 'Bulgarians trained',
    mission_stat3_num: '20+',
    mission_stat3_label: 'Seminars & lectures',
    mission_stat4_num: '3',
    mission_stat4_label: 'Partner organizations',
    mission_pillars_title: 'Pillars of the Mission',
    mission_pillar1_title: 'Financial Education',
    mission_pillar1_desc: 'Seminars, webinars and personal consultations to raise financial literacy',
    mission_pillar2_title: 'Investment Culture',
    mission_pillar2_desc: 'Teaching how to invest wisely and build long-term wealth',
    mission_pillar3_title: 'Economic Growth',
    mission_pillar3_desc: 'Supporting local business and attracting international investment to Bulgaria',
    mission_pillar4_title: 'Personal Commitment',
    mission_pillar4_desc: 'I work personally with every client because I believe in the individual approach',
  },
  it: {
    nav_home: 'Home',
    nav_about: 'Chi sono',
    nav_mission: 'Missione',
    nav_experience: 'Esperienza',
    nav_testimonials: 'Recensioni',
    nav_clients: 'Clienti',
    nav_contact: 'Contatti',
    nav_cta: 'Contattami',
    nav_subtitle: 'Analista Finanziario',
    hero_title: 'Alex Zinger',
    hero_subtitle: 'Analista Finanziario Professionista',
    hero_desc: 'Ex esperto di HSBC Bank con oltre 25 anni di esperienza nei mercati finanziari globali',
    hero_cta: 'Consulenza',
    hero_learn: 'Scopri di più',
    hero_years: 'Anni di esperienza',
    hero_clients: 'Clienti soddisfatti',
    hero_countries: 'Paesi',
    about_title: 'Chi sono',
    about_p1: 'Con oltre <b>25 anni di esperienza professionale</b> nei mercati finanziari globali, mi specializzo nell\'analisi approfondita delle opportunità di investimento e nella gestione strategica del portafoglio.',
    about_p2: 'Durante gli anni in <b>HSBC Bank</b>, ho sviluppato competenze nell\'analisi dei mercati internazionali, nella valutazione dei rischi e nella creazione di strategie di investimento personalizzate per clienti di tutto il mondo.',
    about_p3: 'A <b>49 anni</b>, continuo ad aiutare investitori e aziende a prendere decisioni finanziarie informate basate su un\'analisi tecnica e fondamentale approfondita.',
    about_skill1_title: 'Analisi Tecnica',
    about_skill1_desc: 'Competenza in candele giapponesi, modelli grafici e indicatori',
    about_skill2_title: 'Mercati Globali',
    about_skill2_desc: 'Profonda conoscenza dei mercati finanziari internazionali',
    about_skill3_title: 'Gestione del Rischio',
    about_skill3_desc: 'Strategie per proteggere e ottimizzare gli investimenti',
    exp_title: 'Esperienza Professionale',
    exp_key: 'Risultati chiave:',
    exp1_period: '1998 - 2023',
    exp1_company: 'HSBC Bank',
    exp1_position: 'Analista Finanziario Senior',
    exp1_desc: 'Guida di un team di analisti, sviluppo di strategie di investimento per clienti istituzionali, analisi dei mercati globali e delle tendenze macroeconomiche.',
    exp1_a1: 'Gestione di portafogli del valore di oltre $500M',
    exp1_a2: 'Sviluppo di 50+ strategie di investimento di successo',
    exp1_a3: 'Consulenza a clienti di 45+ paesi',
    exp2_period: '1995 - 1998',
    exp2_company: 'Corporazione Finanziaria Internazionale',
    exp2_position: 'Analista Finanziario',
    exp2_desc: 'Analisi dei mercati emergenti, valutazione delle opportunità di investimento, preparazione di rapporti finanziari e previsioni.',
    exp2_a1: 'Analisi di 100+ progetti di investimento',
    exp2_a2: 'Partecipazione a forum finanziari internazionali',
    exp2_a3: 'Sviluppo di modelli di valutazione del rischio',
    stat_certs: 'Certificati',
    stat_projects: 'Progetti',
    stat_clients: 'Clienti',
    stat_roi: 'ROI medio',
    test_title: 'Recensioni dei clienti',
    test_subtitle: 'Cosa dicono i miei clienti del mio lavoro',
    map_title: 'Presenza Globale',
    map_subtitle: 'Clienti da tutto il mondo si affidano alla mia competenza',
    map_total: 'Clienti totali nel mondo',
    map_clients: 'clienti',
    region_europe: 'Europa',
    region_asia: 'Asia',
    region_na: 'Nord America',
    region_sa: 'Sud America',
    region_africa: 'Africa',
    region_australia: 'Australia',
    contact_title: 'Contattami',
    contact_subtitle: 'Pronto a discutere i tuoi obiettivi di investimento',
    contact_info: 'Informazioni di contatto',
    contact_email_label: 'Email',
    contact_phone_label: 'Telefono',
    contact_hours_label: 'Orario di lavoro',
    contact_hours_val: 'Lun - Ven: 9:00 - 18:00',
    contact_why: 'Perché lavorare con me?',
    contact_why1: '25+ anni di esperienza professionale',
    contact_why2: 'Approccio personalizzato per ogni cliente',
    contact_why3: 'Risultati e rendimenti comprovati',
    contact_why4: 'Competenza e rete globale',
    contact_messenger: 'Contattami direttamente tramite il tuo messenger preferito',
    contact_reply: 'Rispondo entro 24 ore nei giorni lavorativi',
    footer_title: 'Alex Zinger',
    footer_subtitle: 'Analista Finanziario Professionista',
    footer_copy: '© 2024 Alex Zinger. Tutti i diritti riservati.',
    mission_badge: 'Missione in Bulgaria',
    mission_title: 'Missione in Bulgaria',
    mission_subtitle: 'Aumentare la cultura finanziaria e sollevare l\'economia bulgara',
    mission_quote: 'Mio padre è bulgaro — questa terra è nel mio sangue. Il mio sogno è restituire alla Bulgaria ciò che mi ha dato.',
    mission_quote_author: 'Alex Zinger',
    mission_p1: 'Dal <b>2023</b> lavoro attivamente con la Bulgaria con un obiettivo chiaro — aiutare le persone qui a capire come funzionano i mercati finanziari e come possono costruire un futuro finanziario stabile.',
    mission_p2: 'Come figlio di un <b>padre bulgaro</b>, ho sempre sentito un profondo legame con questo paese. Vedo un enorme potenziale nei bulgari — persone intelligenti, laboriose e ambiziose che semplicemente mancano di accesso a un\'educazione finanziaria di qualità.',
    mission_p3: 'Il mio obiettivo è <b>costruire una generazione finanziariamente alfabetizzata</b> in Bulgaria — persone che capiscono gli investimenti, gestiscono i rischi e contribuiscono alla crescita dell\'economia nazionale.',
    mission_since_label: 'Lavoro con la Bulgaria dal',
    mission_since_val: 'Anno 2023',
    mission_photo_caption: 'Alex Zinger, Sofia',
    mission_photo_sub: 'Cattedrale Alexander Nevsky',
    mission_stat1_num: '2023',
    mission_stat1_label: 'Inizio missione',
    mission_stat2_num: '500+',
    mission_stat2_label: 'Bulgari formati',
    mission_stat3_num: '20+',
    mission_stat3_label: 'Seminari e lezioni',
    mission_stat4_num: '3',
    mission_stat4_label: 'Organizzazioni partner',
    mission_pillars_title: 'I Pilastri della Missione',
    mission_pillar1_title: 'Educazione Finanziaria',
    mission_pillar1_desc: 'Seminari, webinar e consulenze personali per aumentare la cultura finanziaria',
    mission_pillar2_title: 'Cultura degli Investimenti',
    mission_pillar2_desc: 'Insegnare come investire saggiamente e costruire ricchezza a lungo termine',
    mission_pillar3_title: 'Crescita Economica',
    mission_pillar3_desc: 'Supporto alle imprese locali e attrazione di investimenti internazionali in Bulgaria',
    mission_pillar4_title: 'Impegno Personale',
    mission_pillar4_desc: 'Lavoro personalmente con ogni cliente perché credo nell\'approccio individuale',
  },
  ar: {
    nav_home: 'الرئيسية',
    nav_about: 'عني',
    nav_mission: 'المهمة',
    nav_experience: 'الخبرة',
    nav_testimonials: 'التقييمات',
    nav_clients: 'العملاء',
    nav_contact: 'اتصل بي',
    nav_cta: 'تواصل معي',
    nav_subtitle: 'محلل مالي',
    hero_title: 'أليكس زينجر',
    hero_subtitle: 'محلل مالي محترف',
    hero_desc: 'خبير سابق في بنك HSBC مع أكثر من 25 عامًا من الخبرة في الأسواق المالية العالمية',
    hero_cta: 'استشارة',
    hero_learn: 'اعرف المزيد',
    hero_years: 'سنوات الخبرة',
    hero_clients: 'عملاء راضون',
    hero_countries: 'دولة',
    about_title: 'عني',
    about_p1: 'مع أكثر من <b>25 عامًا من الخبرة المهنية</b> في الأسواق المالية العالمية، أتخصص في التحليل العميق لفرص الاستثمار والإدارة الاستراتيجية للمحافظ.',
    about_p2: 'خلال سنوات عملي في <b>بنك HSBC</b>، طورت خبرة في تحليل الأسواق الدولية وتقييم المخاطر وإنشاء استراتيجيات استثمار مخصصة للعملاء حول العالم.',
    about_p3: 'في سن <b>49 عامًا</b>، أواصل مساعدة المستثمرين والشركات على اتخاذ قرارات مالية مستنيرة بناءً على تحليل تقني وأساسي متعمق.',
    about_skill1_title: 'التحليل الفني',
    about_skill1_desc: 'خبرة في الشموع اليابانية والأنماط البيانية والمؤشرات',
    about_skill2_title: 'الأسواق العالمية',
    about_skill2_desc: 'معرفة عميقة بالأسواق المالية الدولية',
    about_skill3_title: 'إدارة المخاطر',
    about_skill3_desc: 'استراتيجيات لحماية الاستثمارات وتحسينها',
    exp_title: 'الخبرة المهنية',
    exp_key: 'الإنجازات الرئيسية:',
    exp1_period: '1998 - 2023',
    exp1_company: 'بنك HSBC',
    exp1_position: 'محلل مالي أول',
    exp1_desc: 'قيادة فريق من المحللين، وتطوير استراتيجيات الاستثمار للعملاء المؤسسيين، وتحليل الأسواق العالمية والاتجاهات الاقتصادية الكلية.',
    exp1_a1: 'إدارة محافظ بقيمة تزيد عن 500 مليون دولار',
    exp1_a2: 'تطوير أكثر من 50 استراتيجية استثمار ناجحة',
    exp1_a3: 'تقديم الاستشارات لعملاء من أكثر من 45 دولة',
    exp2_period: '1995 - 1998',
    exp2_company: 'مؤسسة التمويل الدولية',
    exp2_position: 'محلل مالي',
    exp2_desc: 'تحليل الأسواق الناشئة، وتقييم فرص الاستثمار، وإعداد التقارير المالية والتوقعات.',
    exp2_a1: 'تحليل أكثر من 100 مشروع استثماري',
    exp2_a2: 'المشاركة في المنتديات المالية الدولية',
    exp2_a3: 'تطوير نماذج تقييم المخاطر',
    stat_certs: 'شهادات',
    stat_projects: 'مشاريع',
    stat_clients: 'عملاء',
    stat_roi: 'متوسط العائد',
    test_title: 'آراء العملاء',
    test_subtitle: 'ما يقوله عملائي عن عملي',
    map_title: 'الحضور العالمي',
    map_subtitle: 'يثق بخبرتي عملاء من جميع أنحاء العالم',
    map_total: 'إجمالي العملاء حول العالم',
    map_clients: 'عميل',
    region_europe: 'أوروبا',
    region_asia: 'آسيا',
    region_na: 'أمريكا الشمالية',
    region_sa: 'أمريكا الجنوبية',
    region_africa: 'أفريقيا',
    region_australia: 'أستراليا',
    contact_title: 'تواصل معي',
    contact_subtitle: 'مستعد لمناقشة أهدافك الاستثمارية',
    contact_info: 'معلومات الاتصال',
    contact_email_label: 'البريد الإلكتروني',
    contact_phone_label: 'الهاتف',
    contact_hours_label: 'ساعات العمل',
    contact_hours_val: 'الاثنين - الجمعة: 9:00 - 18:00',
    contact_why: 'لماذا تعمل معي؟',
    contact_why1: 'أكثر من 25 عامًا من الخبرة المهنية',
    contact_why2: 'نهج مخصص لكل عميل',
    contact_why3: 'نتائج وعوائد مثبتة',
    contact_why4: 'خبرة وشبكة عالمية',
    contact_messenger: 'تواصل معي مباشرة عبر تطبيق المراسلة المفضل لديك',
    contact_reply: 'أرد خلال 24 ساعة في أيام العمل',
    footer_title: 'أليكس زينجر',
    footer_subtitle: 'محلل مالي محترف',
    footer_copy: '© 2024 أليكس زينجر. جميع الحقوق محفوظة.',
    mission_badge: 'مهمة في بلغاريا',
    mission_title: 'مهمة في بلغاريا',
    mission_subtitle: 'رفع مستوى الثقافة المالية والنهوض بالاقتصاد البلغاري',
    mission_quote: 'والدي بلغاري — هذه الأرض في دمي. حلمي هو أن أرد لبلغاريا ما أعطتني إياه.',
    mission_quote_author: 'أليكس زينجر',
    mission_p1: 'منذ <b>عام 2023</b>، أعمل بنشاط مع بلغاريا بهدف واضح — مساعدة الناس هنا على فهم كيفية عمل الأسواق المالية وكيف يمكنهم بناء مستقبل مالي مستقر.',
    mission_p2: 'بوصفي ابناً لـ<b>أب بلغاري</b>، شعرت دائماً بارتباط عميق بهذا البلد. أرى إمكانات هائلة في البلغاريين — أشخاص أذكياء ومجتهدون وطموحون يفتقرون فقط إلى الوصول إلى تعليم مالي عالي الجودة.',
    mission_p3: 'هدفتي هو <b>بناء جيل متعلم مالياً</b> في بلغاريا — أشخاص يفهمون الاستثمارات ويديرون المخاطر ويساهمون في نمو الاقتصاد الوطني.',
    mission_since_label: 'أعمل مع بلغاريا منذ',
    mission_since_val: 'عام 2023',
    mission_photo_caption: 'أليكس زينجر، صوفيا',
    mission_photo_sub: 'كاتدرائية الإسكندر نيفسكي',
    mission_stat1_num: '2023',
    mission_stat1_label: 'بداية المهمة',
    mission_stat2_num: '+500',
    mission_stat2_label: 'بلغاري تم تدريبهم',
    mission_stat3_num: '+20',
    mission_stat3_label: 'ندوات ومحاضرات',
    mission_stat4_num: '3',
    mission_stat4_label: 'منظمات شريكة',
    mission_pillars_title: 'ركائز المهمة',
    mission_pillar1_title: 'التعليم المالي',
    mission_pillar1_desc: 'ندوات وويبينارات واستشارات شخصية لرفع مستوى الثقافة المالية',
    mission_pillar2_title: 'ثقافة الاستثمار',
    mission_pillar2_desc: 'تعليم كيفية الاستثمار بحكمة وبناء الثروة على المدى الطويل',
    mission_pillar3_title: 'النمو الاقتصادي',
    mission_pillar3_desc: 'دعم الأعمال المحلية وجذب الاستثمارات الدولية إلى بلغاريا',
    mission_pillar4_title: 'الالتزام الشخصي',
    mission_pillar4_desc: 'أعمل شخصياً مع كل عميل لأنني أؤمن بالنهج الفردي',
  },
  zh: {
    nav_home: '首页',
    nav_about: '关于我',
    nav_mission: '使命',
    nav_experience: '经验',
    nav_testimonials: '评价',
    nav_clients: '客户',
    nav_contact: '联系',
    nav_cta: '联系我',
    nav_subtitle: '金融分析师',
    hero_title: '亚历克斯·辛格',
    hero_subtitle: '专业金融分析师',
    hero_desc: '前汇丰银行专家，拥有25年以上全球金融市场经验',
    hero_cta: '咨询',
    hero_learn: '了解更多',
    hero_years: '年经验',
    hero_clients: '满意客户',
    hero_countries: '国家',
    about_title: '关于我',
    about_p1: '凭借超过<b>25年的专业经验</b>在全球金融市场，我专注于深入分析投资机会和战略投资组合管理。',
    about_p2: '在<b>汇丰银行</b>工作期间，我在国际市场分析、风险评估以及为全球客户制定个性化投资策略方面积累了丰富的专业知识。',
    about_p3: '在<b>49岁</b>，我继续帮助投资者和企业基于深入的技术和基本面分析做出明智的财务决策。',
    about_skill1_title: '技术分析',
    about_skill1_desc: '精通日本蜡烛图、图表形态和指标',
    about_skill2_title: '全球市场',
    about_skill2_desc: '深入了解国际金融市场',
    about_skill3_title: '风险管理',
    about_skill3_desc: '保护和优化投资的策略',
    exp_title: '专业经验',
    exp_key: '主要成就：',
    exp1_period: '1998 - 2023',
    exp1_company: '汇丰银行',
    exp1_position: '高级金融分析师',
    exp1_desc: '领导分析师团队，为机构客户制定投资策略，分析全球市场和宏观经济趋势。',
    exp1_a1: '管理价值超过5亿美元的投资组合',
    exp1_a2: '制定50多个成功的投资策略',
    exp1_a3: '为45个以上国家的客户提供咨询',
    exp2_period: '1995 - 1998',
    exp2_company: '国际金融公司',
    exp2_position: '金融分析师',
    exp2_desc: '分析新兴市场，评估投资机会，准备财务报告和预测。',
    exp2_a1: '分析100多个投资项目',
    exp2_a2: '参与国际金融论坛',
    exp2_a3: '开发风险评估模型',
    stat_certs: '证书',
    stat_projects: '项目',
    stat_clients: '客户',
    stat_roi: '平均回报率',
    test_title: '客户评价',
    test_subtitle: '我的客户对我工作的评价',
    map_title: '全球影响力',
    map_subtitle: '来自世界各地的客户信任我的专业知识',
    map_total: '全球客户总数',
    map_clients: '客户',
    region_europe: '欧洲',
    region_asia: '亚洲',
    region_na: '北美洲',
    region_sa: '南美洲',
    region_africa: '非洲',
    region_australia: '澳大利亚',
    contact_title: '联系我',
    contact_subtitle: '准备好讨论您的投资目标',
    contact_info: '联系信息',
    contact_email_label: '电子邮件',
    contact_phone_label: '电话',
    contact_hours_label: '工作时间',
    contact_hours_val: '周一至周五：9:00 - 18:00',
    contact_why: '为什么选择我？',
    contact_why1: '25年以上专业经验',
    contact_why2: '针对每位客户的个性化方法',
    contact_why3: '经过验证的结果和回报',
    contact_why4: '全球专业知识和网络',
    contact_messenger: '通过您喜欢的即时通讯工具直接联系我',
    contact_reply: '工作日内24小时内回复',
    footer_title: '亚历克斯·辛格',
    footer_subtitle: '专业金融分析师',
    footer_copy: '© 2024 亚历克斯·辛格。保留所有权利。',
    mission_badge: '保加利亚使命',
    mission_title: '保加利亚使命',
    mission_subtitle: '提升金融素养，振兴保加利亚经济',
    mission_quote: '我的父亲是保加利亚人——这片土地流淌在我的血液中。我的梦想是回馈保加利亚所给予我的一切。',
    mission_quote_author: '亚历克斯·辛格',
    mission_p1: '自<b>2023年</b>起，我积极与保加利亚合作，目标明确——帮助这里的人们了解金融市场的运作方式，以及如何为自己和家人建立稳定的财务未来。',
    mission_p2: '作为一位<b>保加利亚父亲</b>的儿子，我始终对这个国家怀有深厚的情感。我看到保加利亚人身上巨大的潜力——聪明、勤劳、有抱负，只是缺乏获得优质金融教育的途径。',
    mission_p3: '我的目标是在保加利亚<b>培养具有金融素养的一代人</b>——懂得投资、管理风险并为国家经济增长做出贡献的人。',
    mission_since_label: '与保加利亚合作始于',
    mission_since_val: '2023年',
    mission_photo_caption: '亚历克斯·辛格，索非亚',
    mission_photo_sub: '亚历山大·涅夫斯基大教堂',
    mission_stat1_num: '2023',
    mission_stat1_label: '使命开始',
    mission_stat2_num: '500+',
    mission_stat2_label: '受训保加利亚人',
    mission_stat3_num: '20+',
    mission_stat3_label: '研讨会与讲座',
    mission_stat4_num: '3',
    mission_stat4_label: '合作伙伴组织',
    mission_pillars_title: '使命支柱',
    mission_pillar1_title: '金融教育',
    mission_pillar1_desc: '通过研讨会、网络研讨会和个人咨询提升金融素养',
    mission_pillar2_title: '投资文化',
    mission_pillar2_desc: '教导如何明智投资并积累长期财富',
    mission_pillar3_title: '经济增长',
    mission_pillar3_desc: '支持本地企业并吸引国际投资进入保加利亚',
    mission_pillar4_title: '个人承诺',
    mission_pillar4_desc: '我亲自与每位客户合作，因为我相信个性化方法',
  },
  ru: {
    nav_home: 'Главная',
    nav_about: 'Обо мне',
    nav_mission: 'Миссия',
    nav_experience: 'Опыт',
    nav_testimonials: 'Отзывы',
    nav_clients: 'Клиенты',
    nav_contact: 'Контакты',
    nav_cta: 'Связаться',
    nav_subtitle: 'Финансовый аналитик',
    hero_title: 'Алекс Зингер',
    hero_subtitle: 'Профессиональный финансовый аналитик',
    hero_desc: 'Бывший эксперт HSBC Bank с 25+ годами опыта на глобальных финансовых рынках',
    hero_cta: 'Консультация',
    hero_learn: 'Узнать больше',
    hero_years: 'Лет опыта',
    hero_clients: 'Довольных клиентов',
    hero_countries: 'Стран',
    about_title: 'Обо мне',
    about_p1: 'Имея более <b>25 лет профессионального опыта</b> на глобальных финансовых рынках, я специализируюсь на глубоком анализе инвестиционных возможностей и стратегическом управлении портфелями.',
    about_p2: 'За годы работы в <b>HSBC Bank</b> я развил экспертизу в анализе международных рынков, оценке рисков и создании персонализированных инвестиционных стратегий для клиентов со всего мира.',
    about_p3: 'В <b>49 лет</b> я продолжаю помогать инвесторам и компаниям принимать взвешенные финансовые решения, основанные на глубоком техническом и фундаментальном анализе.',
    about_skill1_title: 'Технический анализ',
    about_skill1_desc: 'Экспертиза в японских свечах, графических паттернах и индикаторах',
    about_skill2_title: 'Глобальные рынки',
    about_skill2_desc: 'Глубокое знание международных финансовых рынков',
    about_skill3_title: 'Управление рисками',
    about_skill3_desc: 'Стратегии для защиты и оптимизации инвестиций',
    exp_title: 'Профессиональный опыт',
    exp_key: 'Ключевые достижения:',
    exp1_period: '1998 - 2023',
    exp1_company: 'HSBC Bank',
    exp1_position: 'Старший финансовый аналитик',
    exp1_desc: 'Руководство командой аналитиков, разработка инвестиционных стратегий для институциональных клиентов, анализ глобальных рынков и макроэкономических тенденций.',
    exp1_a1: 'Управление портфелями стоимостью свыше $500M',
    exp1_a2: 'Разработка 50+ успешных инвестиционных стратегий',
    exp1_a3: 'Консультирование клиентов из 45+ стран',
    exp2_period: '1995 - 1998',
    exp2_company: 'Международная финансовая корпорация',
    exp2_position: 'Финансовый аналитик',
    exp2_desc: 'Анализ развивающихся рынков, оценка инвестиционных возможностей, подготовка финансовых отчётов и прогнозов.',
    exp2_a1: 'Анализ 100+ инвестиционных проектов',
    exp2_a2: 'Участие в международных финансовых форумах',
    exp2_a3: 'Разработка моделей оценки рисков',
    stat_certs: 'Сертификаты',
    stat_projects: 'Проекты',
    stat_clients: 'Клиенты',
    stat_roi: 'Средний ROI',
    test_title: 'Отзывы клиентов',
    test_subtitle: 'Что говорят мои клиенты о работе со мной',
    map_title: 'Глобальное присутствие',
    map_subtitle: 'Клиенты со всего мира доверяют моей экспертизе',
    map_total: 'Всего клиентов по миру',
    map_clients: 'клиентов',
    region_europe: 'Европа',
    region_asia: 'Азия',
    region_na: 'Северная Америка',
    region_sa: 'Южная Америка',
    region_africa: 'Африка',
    region_australia: 'Австралия',
    contact_title: 'Свяжитесь со мной',
    contact_subtitle: 'Готов обсудить ваши инвестиционные цели',
    contact_info: 'Контактная информация',
    contact_email_label: 'Email',
    contact_phone_label: 'Телефон',
    contact_hours_label: 'Рабочее время',
    contact_hours_val: 'Пн - Пт: 9:00 - 18:00',
    contact_why: 'Почему стоит работать со мной?',
    contact_why1: '25+ лет профессионального опыта',
    contact_why2: 'Персональный подход к каждому клиенту',
    contact_why3: 'Доказанные результаты и доходность',
    contact_why4: 'Компетенция и мировая сеть',
    contact_messenger: 'Свяжитесь со мной напрямую через удобный мессенджер',
    contact_reply: 'Отвечаю в течение 24 часов в рабочие дни',
    footer_title: 'Алекс Зингер',
    footer_subtitle: 'Профессиональный финансовый аналитик',
    footer_copy: '© 2024 Алекс Зингер. Все права защищены.',
    mission_badge: 'Миссия в Болгарии',
    mission_title: 'Миссия в Болгарии',
    mission_subtitle: 'Повышение финансовой грамотности и подъём экономики Болгарии',
    mission_quote: 'Мой отец — болгарин, эта земля в моей крови. Моя мечта — вернуть Болгарии то, что она мне дала.',
    mission_quote_author: 'Алекс Зингер',
    mission_p1: 'С <b>2023 года</b> я активно работаю с Болгарией с одной чёткой целью — помочь людям здесь понять, как работают финансовые рынки и как они могут построить стабильное финансовое будущее для себя и своих семей.',
    mission_p2: 'Как сын <b>болгарского отца</b>, я всегда чувствовал глубокую связь с этой страной. Я вижу огромный потенциал в болгарах — умных, трудолюбивых и амбициозных людей, которым просто не хватает доступа к качественному финансовому образованию.',
    mission_p3: 'Моя цель — <b>воспитать финансово грамотное поколение</b> в Болгарии — людей, которые понимают инвестиции, управляют рисками и вносят вклад в рост национальной экономики.',
    mission_since_label: 'Работаю с Болгарией с',
    mission_since_val: '2023 года',
    mission_photo_caption: 'Алекс Зингер, София',
    mission_photo_sub: 'Собор Александра Невски',
    mission_stat1_num: '2023',
    mission_stat1_label: 'Начало миссии',
    mission_stat2_num: '500+',
    mission_stat2_label: 'Обученных болгар',
    mission_stat3_num: '20+',
    mission_stat3_label: 'Семинаров и лекций',
    mission_stat4_num: '3',
    mission_stat4_label: 'Партнёрских организации',
    mission_pillars_title: 'Столпы миссии',
    mission_pillar1_title: 'Финансовое образование',
    mission_pillar1_desc: 'Семинары, вебинары и личные консультации для повышения финансовой грамотности',
    mission_pillar2_title: 'Инвестиционная культура',
    mission_pillar2_desc: 'Обучение разумному инвестированию и построению долгосрочного благосостояния',
    mission_pillar3_title: 'Экономический рост',
    mission_pillar3_desc: 'Поддержка местного бизнеса и привлечение международных инвестиций в Болгарию',
    mission_pillar4_title: 'Личная вовлечённость',
    mission_pillar4_desc: 'Работаю лично с каждым клиентом, потому что верю в индивидуальный подход',
  },
};

export const langNames: Record<Lang, string> = {
  bg: 'БГ',
  en: 'EN',
  it: 'IT',
  ar: 'AR',
  zh: '中文',
  ru: 'РУ',
};

export const langFlags: Record<Lang, string> = {
  bg: '🇧🇬',
  en: '🇬🇧',
  it: '🇮🇹',
  ar: '🇸🇦',
  zh: '🇨🇳',
  ru: '🇷🇺',
};
